import "./InputComp.css";
import { defineComponent as c, useCssVars as y, resolveComponent as b, openBlock as o, createElementBlock as i, normalizeClass as d, normalizeStyle as v, createVNode as S, createSlots as $, withCtx as n, createElementVNode as l, renderSlot as a, withKeys as C, toDisplayString as M, createCommentVNode as u, normalizeProps as p, guardReactiveProps as h } from "vue";
import { V, W as E } from "./WrapperComp.204dcf4e.js";
import { i as B } from "./isNil.6f60d6a4.js";
import { u as I } from "./uniqueId.f48d78c2.js";
import { _ as T } from "./_plugin-vue_export-helper.dad06003.js";
const r = c({
  mixins: [V],
  components: {
    WrapperComp: E
  },
  events: {
    "update:modelValue": {
      type: String,
      Note: "Emits input type back"
    },
    "update:errorMessages": {
      type: Array,
      Note: "Updates the Error message array"
    }
  },
  props: {
    id: {
      type: String,
      required: !1,
      default: () => I("inputComp")
    },
    type: {
      type: String,
      default: "text"
    },
    modelValue: {
      type: String,
      default: "",
      Note: "This is the actual v-model of the component"
    },
    validationRules: {
      type: Array,
      default: () => []
    },
    errorMessages: {
      type: Array,
      default: () => [],
      Note: 'This is the secondary v-model:errorMessages="" of the component'
    },
    infoMessages: {
      type: Array,
      default: () => []
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    /**
     * Used for disabling error or info messages from being seen or validation from running
     */
    disableMessages: Boolean,
    /**
     * Used for determining when to run the validation rules on input
     */
    validateOn: {
      type: String,
      default: "blur"
    },
    selectAllOnFocus: Boolean,
    maxLength: Number,
    placeholder: String,
    label: String,
    supportingText: String,
    medium: Boolean,
    legacy: Boolean,
    height: String,
    width: String,
    disabled: Boolean,
    /**
     * Default look is the compact label variant, set true to use label above variant
     */
    labelAbove: {
      type: Boolean,
      default: !1
    },
    /**
     * Used for telling the browser/password managers what the input is and how to use it,
     * reference: https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete
     */
    autocomplete: {
      type: String,
      default: "on"
    },
    labelSpecialText: String,
    labelIcon: String
  },
  data() {
    return {
      focused: !1
    };
  },
  mounted() {
    if (this.autofocus) {
      const e = document.getElementById(this.id);
      e && e.focus();
    }
  },
  computed: {
    characterCount() {
      var e;
      return `${((e = this.modelValue) == null ? void 0 : e.length) ?? 0} / ${this.maxLength}`;
    },
    inputContentClasses() {
      return {
        input__content: !0,
        "input__content--error": this.isErrorState,
        "input--medium": this.medium
      };
    },
    styleOverides() {
      return {
        height: this.height,
        width: this.width
      };
    },
    filled() {
      return !B(this.modelValue) && this.modelValue !== "";
    },
    hasPlaceholder() {
      var e;
      return !!((e = this.placeholder) != null && e.trim());
    }
  },
  methods: {
    handleInput(e) {
      this.$emit("update:modelValue", e.target.value);
    },
    handleEnterKey(e) {
      e.key === "Enter" && this.$emit("enterKeyPressed");
    },
    async handleClick() {
      this.$refs.input !== document.activeElement && this.$refs.input.focus();
    },
    handleFocus() {
      this.$emit("focus"), this.focused = !0, this.selectAllOnFocus && this.$refs.input.select();
    },
    async handleBlur() {
      await this.sleep(150), !(this.$refs.inputContainer === document.activeElement || this.$refs.input === document.activeElement) && (this.$emit("blur"), this.focused = !1, this.validateInputOnBlur());
    },
    async sleep(e) {
      return new Promise((t) => setTimeout(t, e));
    },
    hasSlot(e) {
      return !!this.$slots[e];
    },
    validate() {
      const e = this.runValidationMethod(this.modelValue);
      return this.$emit("update:errorMessages", e), e.filter((t) => t.id === this.id);
    }
  }
}), m = () => {
  y((e) => ({
    "6514c8aa": e.width
  }));
}, f = r.setup;
r.setup = f ? (e, t) => (m(), f(e, t)) : m;
const k = { class: "input__prepend" }, w = ["id", "type", "value", "maxlength", "placeholder", "autocomplete", "disabled"], A = {
  key: 0,
  class: "input__characterCount"
}, N = { class: "input__append" }, P = {
  key: 0,
  class: "input__underline"
};
function F(e, t, K, O, R, L) {
  const g = b("wrapper-comp");
  return o(), i("div", {
    class: d(["input", {
      "input--legacy": e.legacy,
      "input--focused": e.focused,
      "input--disabled": e.disabled,
      "input--filled": e.filled,
      "input--error": e.isErrorState,
      "input--placeholder": e.hasPlaceholder
    }]),
    style: v(e.styleOverides)
  }, [
    S(g, {
      id: e.id,
      label: e.label,
      supportingText: e.supportingText,
      validationRules: e.validationRules,
      errorMessages: e.errorMessages,
      disableMessages: e.disableMessages,
      infoMessages: e.infoMessages,
      labelAbove: e.labelAbove,
      disabled: e.disabled,
      hasPlaceholder: e.hasPlaceholder,
      isFocused: e.focused,
      filled: e.filled,
      labelSpecialText: e.labelSpecialText,
      labelIcon: e.labelIcon
    }, $({
      default: n(() => [
        l("div", {
          ref: "inputContainer",
          class: d(e.inputContentClasses),
          onClick: t[4] || (t[4] = (s) => e.handleClick()),
          role: "button"
        }, [
          l("div", k, [
            a(e.$slots, "prepend", {}, void 0, !0)
          ]),
          l("input", {
            id: e.id,
            ref: "input",
            class: "input__input",
            type: e.type,
            value: e.modelValue,
            maxlength: e.maxLength,
            placeholder: e.placeholder,
            onFocus: t[0] || (t[0] = (s) => e.handleFocus()),
            onBlur: t[1] || (t[1] = (s) => e.handleBlur()),
            onInput: t[2] || (t[2] = (...s) => e.handleInput && e.handleInput(...s)),
            onKeyup: t[3] || (t[3] = C((...s) => e.handleEnterKey && e.handleEnterKey(...s), ["enter"])),
            autocomplete: e.autocomplete,
            disabled: e.disabled
          }, null, 40, w),
          e.maxLength ? (o(), i("span", A, M(e.characterCount), 1)) : u("", !0),
          l("div", N, [
            a(e.$slots, "append", {}, void 0, !0)
          ])
        ], 2),
        e.legacy ? (o(), i("span", P)) : u("", !0)
      ]),
      _: 2
    }, [
      e.hasSlot("messages") ? {
        name: "messages",
        fn: n((s) => [
          a(e.$slots, "messages", p(h(s)), void 0, !0)
        ]),
        key: "0"
      } : void 0,
      e.hasSlot("supportingText") ? {
        name: "supportingText",
        fn: n((s) => [
          a(e.$slots, "supportingText", p(h(s)), void 0, !0)
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["id", "label", "supportingText", "validationRules", "errorMessages", "disableMessages", "infoMessages", "labelAbove", "disabled", "hasPlaceholder", "isFocused", "filled", "labelSpecialText", "labelIcon"])
  ], 6);
}
const U = /* @__PURE__ */ T(r, [["render", F], ["__scopeId", "data-v-56f9044b"]]);
export {
  U as InputComp
};
//# sourceMappingURL=InputComp.js.map
